import { render, staticRenderFns } from "./CreateNewPassword.vue?vue&type=template&id=c224497e&scoped=true&"
import script from "./CreateNewPassword.vue?vue&type=script&lang=ts&"
export * from "./CreateNewPassword.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNewPassword.vue?vue&type=style&index=0&id=c224497e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c224497e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
